import React from 'react';
import styled from 'styled-components';

import { Highlights } from './components/Highlights';
import {
  CompleteVehicleEntry,
  VehicleBasic,
  useVehicleRaw,
  VehicleDetail,
  LayoutAdapter,
} from '@oneaudi/vtp-shared';

interface FeatureAppProps {
  vehicleId?: string;
  vehicleRaw?: CompleteVehicleEntry;
  renderOnOneCMS?: boolean;
}

const FeatureApp: React.FC<FeatureAppProps> = ({
  vehicleId,
  vehicleRaw,
  renderOnOneCMS,
}: FeatureAppProps) => {
  let vehicle: VehicleBasic | undefined;
  let vehicleDetail: VehicleDetail | undefined;

  if (vehicleRaw) {
    vehicle = vehicleRaw.basic;
    vehicleDetail = vehicleRaw.detail;
  } else if (!vehicleRaw && vehicleId) {
    const completeVehicleEntry = useVehicleRaw(vehicleId);
    vehicle = completeVehicleEntry.vehicleRaw?.basic;
    vehicleDetail = completeVehicleEntry.vehicleRaw?.detail;
  }

  if (!vehicle) {
    return null;
  }

  return (
    <HighlightsFAWrapper>
      <LayoutAdapter>
        <Highlights
          vehicle={vehicle}
          vehicleDetail={vehicleDetail}
          renderOnOneCMS={renderOnOneCMS}
        />
      </LayoutAdapter>
    </HighlightsFAWrapper>
  );
};

export default FeatureApp;
// THIS IS A HOTFIX FOR RELEASE, MARGIN AND CSS MUST BE CLEANED UP
export const HighlightsFAWrapper = styled.div<{ renderOnOneCMS?: boolean }>`
  margin: 0 16px;

  @media (min-width: 375px) {
    margin: 0 28px;
  }
  @media (min-width: 768px) {
    margin: 0 40px;
  }
  @media (min-width: 1024px) {
    margin: 0 60px;
  }
  @media (min-width: 1440px) {
    margin: 0 96px;
  }
`;
